import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the courses state domain
 */

const selectCoursesDomain = state => state.courses || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.firstRender,
  );

const makeSelectItemsList = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.itemsList,
  );

const makeSelectItemsListFirstElem = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.firstElem,
  );

const makeSelectHardDeleteLoading= () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.hardDeleteLoading,
  );

const makeSelectCourse = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate.courseDetail,
  );

/**
 * Default selector used by Courses
 */

const makeSelectCourses = () =>
  createSelector(
    selectCoursesDomain,
    substate => substate,
  );

export default makeSelectCourses;
export {
  selectCoursesDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectItemsList,
  makeSelectItemsListFirstElem,
  makeSelectCourse,
  makeSelectHardDeleteLoading,
};
